import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PrepTourService } from 'src/@prep/shared/tour';
import { GuidedWorkflowI18nService } from '../services/guided-workflow-i18n.service';
import { GuidedWorkflowService } from '../services/guided-workflow.service';

/** Material icon of the "Start work" launcher. */
export const GUIDED_WORKFLOW_ICON = 'assistant_direction';

/**
 * Header launcher of the "Start work" workflow: an icon button in the top
 * toolbar. Renders nothing when the workflow is not offered to this user.
 */
@Component({
  selector: 'guided-workflow-launcher',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button *ngIf="workflow.enabled$ | async" #launcher type="button" mat-button class="button guided-workflow-launcher__button"
      [matTooltip]="(i18n.data$ | async)?.launcher?.tooltip" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below"
      [attr.aria-label]="(i18n.data$ | async)?.launcher?.tooltip"
      [disabled]="workflow.running" (click)="workflow.start(launcher)">
      <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
    </button>
  `,
  styles: [`
    .guided-workflow-launcher__button .mat-icon { color: #1976d2; }
  `],
})
export class GuidedWorkflowLauncherComponent implements OnInit, OnDestroy {
  readonly icon = GUIDED_WORKFLOW_ICON;
  private sub?: Subscription;

  constructor(
    readonly workflow: GuidedWorkflowService,
    readonly i18n: GuidedWorkflowI18nService,
    private readonly tour: PrepTourService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // OnPush: the disabled state follows the guide's start / stop.
    this.sub = this.tour.changes$.subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
